const tr = {
  medicalAppointments: {
    attributes: {
      id: 'Id',
      title: 'Título',
      user_phone: 'Telefone',
      priority: 'Prioridade',
      status: 'Status',
      integration_status_sus: 'Status Integração SUS',
      record_filename: 'Arquivo AWS',
      record_mp4: 'Arquivo AWS MP4',
      notes: 'Observações',
      reason: 'Motivo da consulta',
      schedule_appointment_at: 'Agendar',
      appointment_at: 'Agendamento',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
      category: 'Categoria',
      specialty: 'Especialidade',
      doctor: 'Médico',
      corporation_name: 'Empresa',
      user: 'Paciente',
      user_email: 'e-mail',
      user_id: 'Paciente',
      attendant: 'Atendente',
      activities: 'Atividades',
      languages: 'Idiomas',
      no_show_by: 'Quem não compareceu?',
      cancel_reason: 'Qual o motivo do cancelamento?',
    },
    extras: {
      configs: 'Configurações',
      cam: 'Câmera',
      select_cam: 'Selecione sua câmera',
      microphone: 'Microfone',
      select_microphone: 'Selecione seu microfone',
      refresh: 'Recarregar',
      finish_call: 'Finalizar atendimento',
      init_call: 'Ligar para paciente',
      doctor_required: 'O Médico não pode ser em branco',
      no_doctor: 'Nenhum Médico',
      no_attendant: 'Nenhum Atendente',
      no_user: 'Nenhum Usuário',
      joined_channel_success: 'Entrou na vídeo chamada',
      joined_channel_fail: 'Não foi possível entrar na vídeo chamada',
      media_not_supported:
        'O navegador não permitiu o acesso à câmera. Acesse a aplicação por HTTPS (cadeado) e use um navegador atualizado.',
      media_permission_denied:
        'Permissão de câmera/microfone negada. Clique no cadeado da barra de endereço e permita o acesso à câmera e ao microfone.',
      media_not_found:
        'Nenhuma câmera ou microfone foi encontrado. Conecte um dispositivo e tente novamente.',
      media_in_use:
        'A câmera ou o microfone estão sendo usados por outro programa. Feche os demais aplicativos e tente novamente.',
      media_overconstrained:
        'A câmera selecionada não suporta a configuração de vídeo. Tente outra câmera nas configurações.',
      media_error_generic:
        'Não foi possível acessar a câmera/microfone. Verifique as permissões e os dispositivos.',
      left_channel_success: 'Saíu da vídeo chamada',
      left_channel_fail: 'Não foi possível sair da vídeo chamada',
      edit_medical_appointments: 'Editando parceiro',
      show_medical_appointments: 'Visualizando parceiro',
      delete_medical_appointments: 'Excluir parceiro',
      doctor_consulted: 'Consultado com médico',
      doctor_not_consulted: 'Não consultado com médico',
      attendent_not_consulted: 'Não passou pela triagem',
      download_record_doctor: 'Baixar Consulta',
      download_record_doctor_wait: 'Aguarde',
      download_record_attendent: 'Baixar Triagem',
      download_record_attendent_wait: 'Aguarde',
    },
    priority: {
      low: 'Baixa',
      medium: 'Média',
      high: 'Alta',
      priority_low: 'Prioridade Baixa',
      priority_medium: 'Prioridade Média',
      priority_high: 'Prioridade Alta',
    },
    status: {
      new: 'Novo',
      on_approval: 'Em aprovação',
      pre_appointment: 'Pré Atendimento',
      pre_appointment_finished: 'Pré Atendimento Finalizado',
      wait_room: 'Aguardando Consulta',
      wait_room_scheduled: 'Aguardando Consulta Agendada',
      in_consultation: 'Em Consulta Médica',
      ongoing: 'Em Andamento',
      on_schedule: 'Agendamento',
      finished: 'Finalizado',
      no_show: 'Não compareceu',
      canceled: 'Cancelado',
    },
    no_show_by: {
      patient: 'Paciente',
      doctor: 'Médico',
    },
    cancel_reason: {
      rescheduled: 'Reagendamento da consulta',
      technical_issue: 'Problema técnico',
      patient_request: 'Solicitação do paciente',
      scheduled_by_mistake: 'Agendamento realizado indevidamente',
    },
    tabs: {
      appointments: 'Consultas',
      scheduled_appointments: 'Agendamentos',
      appointments_reports: 'Relatório de consultas',
    },
    defSingular: 'Consulta',
    defPlural: 'Consultas',
  },
};

export default tr;
